export default "__VITE_ASSET__CkGLzpEG__"